
import { memo } from 'react';
import { NodeProps, Handle, Position } from '@xyflow/react';
import { User } from 'lucide-react';

interface ActorNodeProps extends NodeProps {
  data: {
    actorText?: string;
    actorColor?: string;
    uuid: string;
  };
  selected: boolean;
}

const ActorNode = memo(({ data, selected }: ActorNodeProps) => {
  const iconColor = data.actorColor || '#6b7280';
  
  return (
    <div className="flex flex-col items-center">
      {/* Container do ícone */}
      <div 
        className={`relative flex items-center justify-center bg-white rounded-full shadow-lg
          w-[94px] h-[94px] ${selected ? 'ring-2 ring-primary' : ''}`}
      >
        <User 
          size={48}
          style={{ color: iconColor }}
          strokeWidth={2}
        />
        
        {/* Handles para conexões */}
        <Handle
          type="target"
          position={Position.Top}
          className="w-3 h-3 bg-gray-400 border-2 border-white rounded-full shadow-sm"
        />
        <Handle
          type="source"
          position={Position.Bottom}
          className="w-3 h-3 bg-gray-400 border-2 border-white rounded-full shadow-sm"
        />
        <Handle
          type="target"
          position={Position.Left}
          id="left"
          className="w-3 h-3 bg-gray-400 border-2 border-white rounded-full shadow-sm"
        />
        <Handle
          type="source"
          position={Position.Right}
          id="right"
          className="w-3 h-3 bg-gray-400 border-2 border-white rounded-full shadow-sm"
        />
      </div>
      
      {/* Texto abaixo do ícone */}
      {data.actorText && (
        <div className="mt-2 text-sm text-center text-gray-700 font-medium max-w-[120px]">
          {data.actorText}
        </div>
      )}
    </div>
  );
});

ActorNode.displayName = 'ActorNode';

export { ActorNode };
